import { Component, Input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

export interface PortalNavigationItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-portal-navigation',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './portal-navigation.html',
  styleUrl: './portal-navigation.scss'
})
export class PortalNavigation {

  @Input({ required: true }) portalName = '';
  @Input() portalIcon = 'bi-heart-pulse-fill';
  @Input() portalClass = 'text-primary';
  @Input() collapseId = 'portalMenu';
  @Input() firstName = '';
  @Input() lastName = '';
  @Input() primaryItems: PortalNavigationItem[] = [];
  @Input() profileRoute = '/dashboard/profile';
  @Input() settingsRoute = '/dashboard/settings';
  @Input() additionalItems: PortalNavigationItem[] = [];

  constructor(private router: Router) {}

  navigate(route: string): void {
    this.router.navigateByUrl(route);
  }

  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigateByUrl('/login');
  }
}